
export function trimStartZero() {

    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope, element, attr, ngModelCtrl) => {

            function cleaning() {

                let cleaned = '';

                if (ngModelCtrl.$viewValue) {

                    cleaned = ngModelCtrl.$viewValue.replace(/^[0]+/g,"").trim();

                    ngModelCtrl.$setViewValue(cleaned);
    
                    ngModelCtrl.$render();
                }

                return cleaned;
            }

            ngModelCtrl.$parsers.push(cleaning);
        }
    };
}



// WEBPACK FOOTER //
// ./src/ui/directives/trim-start-zero.directive.js